<script setup lang="ts">
import { PropertyId } from "~/classes/entity"

const { addSearchFacet } = useInstantMenu()

const onColorSimilarityClicked = (toggle: () => void) => {
  const facetType = { nearColor: "#FF0000" }
  addSearchFacet({ propertyId: PropertyId.FILE_VIRTUAL_EMBEDDINGS, facetType })
  toggle()
}

const onFileSimilarityClicked = (toggle: () => void) => {
  const facetType = { nearFile: "" }
  addSearchFacet({ propertyId: PropertyId.FILE_VIRTUAL_EMBEDDINGS, facetType })
  toggle()
}
</script>

<template>
  <dropdown
    anchor-x="left"
    anchor-y="bottom"
    flow-x="right"
    flow-y="down"
  >
    <template #default="{ toggle }">
      <nav-instant-shortcut
        label="Similarity"
        @click="toggle()"
      />
    </template>
    <template #menu="{ toggle }">
      <dropdown-menu class="inline-select-container">
        <div class="inline-select-dropdown">
          <menu-section>
            <div class="inline-select-option-container" @click="onColorSimilarityClicked(toggle)">
              <div class="inline-select-option">
                Color similarity
              </div>
            </div>
            <div class="inline-select-option-container" @click="onFileSimilarityClicked(toggle)">
              <div class="inline-select-option">
                Content similarity
              </div>
            </div>
          </menu-section>
        </div>
      </dropdown-menu>
    </template>
  </dropdown>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.inline-select-container
  @apply mt-2

.inline-select-dropdown
  @apply flex flex-col
  @apply overflow-auto
  max-height: calc(100vh - 60px)

.inline-select-option-container
  @apply flex flex-grow cursor-pointer items-center
  @apply rounded-[#{$menu-br-item}] m-[#{$menu-m-hover-outer}] p-[#{$menu-p-hover-inner}]
  @apply text-[#{$global-t-default}] t-menu-sm
  @apply flex cursor-pointer items-center
  @apply rounded-[#{$menu-br-item}] hover:bg-[#{$menu-bg-item-hover}]
  .icon
    @apply ml-auto h-4 w-4 text-[#{$global-bg-icon-secondary}]

.inline-select-option
  @apply flex items-center
</style>
